import { h } from "preact";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { classNames } from "../helpers";
import { getSidebarLinks } from "../services/navigationLinks";
import { selectIsLoggedIn, selectSeeingCompanyPages } from "../store";

import SidebarLink from "./SidebarLink.jsx";

export default function AppSidebar({ previewMode, ...props }) {
  const seeingCompanyPages = useSelector(selectSeeingCompanyPages);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const links = getSidebarLinks(seeingCompanyPages, isLoggedIn, previewMode);

  return (
    <div class={classNames("app-sidebar", props.class)}>
      <div class="app-sidebar__top">
        <Link
          class="app-sidebar__logo"
          to={previewMode ? "/preview/talents" : "/app"}
        >
          <img src="/images/logo_on_dark.svg" width="92" height="36" />
        </Link>
      </div>

      <div class="app-sidebar__links">
        {links.map((link) => (
          <SidebarLink class="app-sidebar__link" {...link} />
        ))}
      </div>

      <div class="app-sidebar__bottom">
        <div class="app-sidebar__footer"></div>
      </div>
    </div>
  );
}
